import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="error-modal-title">
        {{ modalTitleKey | translate }}
      </h4>
      <button
        type="button"
        class="btn-close"
        [attr.aria-label]="'rspModalCloseButtonAriaLabel' | translate"
        (click)="activeModal.dismiss('abort')"
      ></button>
    </div>
    <div class="modal-body" id="error-modal-body">
      {{ modalBodyKey | translate }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('close')">
        {{ modalButtonCloseKey | translate }}
      </button>
      @if (modalButtonCancelKey) {
        <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss('close')">
          {{ modalButtonCancelKey | translate }}
        </button>
      }
    </div>
  `,
  imports: [TranslateModule],
})
export class ErrorModalComponent {
  @Input() modalBodyKey: string;
  @Input() modalTitleKey: string;
  @Input() modalButtonCloseKey: string;
  @Input() modalButtonCancelKey: string;

  constructor(public activeModal: NgbActiveModal) {}
}
